import facebookLogo from './compAssets/facebook.png';
import xLogo from './compAssets/X.png';
import instaLogo from './compAssets/instagram.png';
import linkedinLogo from './compAssets/linkedin.png';

import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <section className="bg-forest_deep text-cream border-t-4 border-gold">

            <div className="max-w-5xl mx-auto w-full px-4">
                <div className="flex flex-col md:flex-row justify-between px-4 sm:px-8 py-10 gap-10">
                    <div id="footer-socials" className="flex flex-col items-start max-w-xs">
                        <Link to="/" className="flex items-center gap-3 mb-4">
                            <img className="h-12 w-auto" src="/official_logo.png" alt="OLI Gardens logo" />
                            <span className="font-lulo font-bold text-cream">OLI Gardens</span>
                        </Link>
                        <p className="text-cream/70 text-sm leading-relaxed mb-4">
                            Growing food. Building community. Honoring heroes.
                        </p>
                        <div className="oli-label text-gold_soft mb-3">Follow Along</div>

                        <div className="flex flex-row items-center gap-2">
                            <a id="X Link" href="https://x.com/gardensoli7022" target="_blank" rel="noreferrer" className="opacity-80 hover:opacity-100 transition-opacity duration-200">
                                <img className="w-8 h-8" src={xLogo} alt="X"/>
                            </a>
                            <a id="Instagram Link" href="https://www.instagram.com/oli_gardens25/" target="_blank" rel="noreferrer" className="opacity-80 hover:opacity-100 transition-opacity duration-200">
                                <img className="w-10 h-10" src={instaLogo} alt="Instagram"/>
                            </a>
                            <a id="Facebook Link" href="https://www.facebook.com/p/OLI-Gardens-100076180795761/" target="_blank" rel="noreferrer" className="opacity-80 hover:opacity-100 transition-opacity duration-200">
                                <img className="w-10 h-10" src={facebookLogo} alt="Facebook"/>
                            </a>
                            <a id="LinkedIn Link" href="https://www.linkedin.com/company/oli-gardens/" target="_blank" rel="noreferrer" className="opacity-80 hover:opacity-100 transition-opacity duration-200">
                                <img className="w-10 h-10" src={linkedinLogo} alt="LinkedIn"/>
                            </a>
                        </div>
                    </div>

                    <div id="footer-lists" className="flex flex-col sm:flex-row justify-start text-left gap-12 flex-1 md:justify-end">
                        <div id="footer-left" className="flex flex-col gap-2">
                            <div className="oli-label text-gold_soft mb-1">About Us</div>
                            <Link to="/" className="text-cream/80 hover:text-gold_soft transition-colors duration-200">Our Mission</Link>
                            <Link to="/history" className="text-cream/80 hover:text-gold_soft transition-colors duration-200">Our History</Link>
                            <Link to="/oli-family" className="text-cream/80 hover:text-gold_soft transition-colors duration-200">Officers &amp; Board</Link>
                            <Link to="/programs" className="text-cream/80 hover:text-gold_soft transition-colors duration-200">Our Programs</Link>
                            <Link to="/faq" className="text-cream/80 hover:text-gold_soft transition-colors duration-200">FAQs</Link>
                        </div>

                        <div id="footer-center" className="flex flex-col gap-2">
                            <div className="oli-label text-gold_soft mb-1">Our Blog</div>
                            <Link to="/blogs?type=Event" className="text-cream/80 hover:text-gold_soft transition-colors duration-200">Events</Link>
                            <Link to="/blogs?type=Garden" className="text-cream/80 hover:text-gold_soft transition-colors duration-200">Gardens</Link>
                            <Link to="/blogs?type=Fundraiser" className="text-cream/80 hover:text-gold_soft transition-colors duration-200">Fundraisers</Link>
                        </div>

                        <div id="footer-right" className="flex flex-col gap-2">
                            <div className="oli-label text-gold_soft mb-1">How to Help</div>
                            <Link to="/donate" className="text-cream/80 hover:text-gold_soft transition-colors duration-200">Donate a Raised Bed</Link>
                            <Link to="/patriotic-signup" className="text-cream/80 hover:text-gold_soft transition-colors duration-200">Plant a Patriotic Garden</Link>
                            <Link to="/find-food-bank" className="text-cream/80 hover:text-gold_soft transition-colors duration-200">Find a Food Pantry</Link>
                            <a href="mailto:info@oligardens.org" className="text-cream/80 hover:text-gold_soft transition-colors duration-200">Contact Us</a>
                        </div>
                    </div>

                </div>
            </div>

            <footer id="copyright" className="text-center text-sm text-cream/60 border-t border-cream/10 pt-5 pb-4 px-4">
                <p>
                    Copyright &copy; 2026 OLI Gardens. All Rights Reserved.
                    OLI Gardens is a 501(c)(3) non-profit recognized by the IRS.
                </p>
            </footer>
        </section>
    );
};

export default Footer;
